export default "__VITE_ASSET__CWBf63gT__"